//@flow
import React, {useState, useEffect} from 'react';
import {
  makeStyles,
  Typography,
  MenuItem,
  Grid,
  IconButton,
} from '@material-ui/core';
import CustomSelect from '../../../../../../elements/CustomSelect/CustomSelect';
import {colors} from '../../../../../../assets/styles/colors';
import {Delete} from '@material-ui/icons';
import {useCrmCustomerCategories} from '../../../../../crm/utils';

import CustomChip from '../../../../../../elements/CustomChip';

import type {FilterRowProps} from '.';

const useStyles = makeStyles(theme => ({
  root: {
    padding: '.5rem',
    borderRadius: '1rem',
    background: colors.grey200,
  },
  chips: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '.25rem',
  },
}));

export default function CrmCustomerCategoryFilter(props: FilterRowProps) {
  const {conditions = {}, onChange, onDelete} = props;

  const {categories: defaultCategories} = conditions;

  const [selectedCategories, setSelectedCategories] = useState([]);

  const [selectOpen, setSelectOpen] = useState(false);

  const handleSelectClose = () => {
    setSelectOpen(false);
  };

  const handleSelectOpen = () => {
    setSelectOpen(true);
  };

  const classes = useStyles();

  const categories = useCrmCustomerCategories();

  useEffect(() => {
    if (!defaultCategories || !categories) return;

    const defaultCategoriesMapped = defaultCategories.map(cat => {
      const category = categories.find(c => c.name === cat);

      return category;
    });

    setSelectedCategories(defaultCategoriesMapped);
  }, [categories, defaultCategories]);

  const handleChange = selectedCategories => {
    if (!onChange) return;
    const newConditions = {
      ...conditions,
      categories: selectedCategories.map(cat => cat.name),
    };

    onChange(newConditions);
  };

  return (
    <Grid container className={classes.root} spacing={1} alignItems="center">
      <Grid item xs={4}>
        <Typography>de la categoría de clientes</Typography>
      </Grid>
      <Grid item xs={6}>
        <CustomSelect
          fullWidth
          multiple
          open={selectOpen}
          onOpen={handleSelectOpen}
          onClose={handleSelectClose}
          value={selectedCategories}
          onChange={e => {
            setSelectedCategories(e.target.value);
            handleSelectClose();
            handleChange(e.target.value);
          }}
          renderValue={selected => (
            <div className={classes.chips}>
              {selected.map(value => (
                <CustomChip color="primary" key={value.id} label={value.name} />
              ))}
            </div>
          )}
        >
          {categories?.map(el => (
            <MenuItem
              key={'text-color-' + el.label}
              value={el}
              className={classes.itemSelectFontColor}
            >
              <Typography>{el.name}</Typography>
            </MenuItem>
          ))}
        </CustomSelect>
      </Grid>

      <Grid item xs={1}></Grid>
      <Grid item xs={1}>
        <IconButton onClick={onDelete}>
          <Delete />
        </IconButton>
      </Grid>
    </Grid>
  );
}
